import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Badge, Spinner, Alert, Modal, Form } from 'react-bootstrap';
import {
  fetchPendingWithdrawals,
  approveWithdrawal,
  rejectWithdrawal,
} from '../../store/slices/walletSlice';

const AdminWithdrawals = () => {
  const dispatch = useDispatch();
  const { pendingWithdrawals, loading, error } = useSelector((s) => s.wallet);
  const [rejectModal, setRejectModal] = useState({ open: false, id: null, reason: '' });

  useEffect(() => {
    dispatch(fetchPendingWithdrawals());
  }, [dispatch]);

  const handleApprove = (id) => {
    if (window.confirm('Approve this withdrawal?')) {
      dispatch(approveWithdrawal(id));
    }
  };

  const openReject = (id) => setRejectModal({ open: true, id, reason: '' });
  const closeReject = () => setRejectModal({ open: false, id: null, reason: '' });

  const handleReject = () => {
    if (!rejectModal.reason.trim()) return;
    dispatch(rejectWithdrawal({ id: rejectModal.id, reason: rejectModal.reason }));
    closeReject();
  };

  const requests = pendingWithdrawals?.requests || [];

  return (
    <div>
      <h5 style={{ fontWeight: 700, marginBottom: 16 }}>Pending Withdrawals</h5>

      {error.pendingWithdrawals && (
        <Alert variant="danger" style={{ fontSize: 13 }}>
          {error.pendingWithdrawals}
        </Alert>
      )}

      {loading.pendingWithdrawals && requests.length === 0 ? (
        <div className="text-center py-4">
          <Spinner animation="border" size="sm" />
        </div>
      ) : requests.length === 0 ? (
        <p className="text-muted" style={{ fontSize: 14 }}>
          No pending withdrawal requests.
        </p>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
          {requests.map((w) => (
            <div
              key={w.id}
              style={{
                padding: '14px 16px',
                borderRadius: 8,
                border: '1px solid #dee2e6',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                flexWrap: 'wrap',
                gap: 8,
              }}
            >
              <div>
                <div style={{ fontWeight: 700, fontSize: 15 }}>₹{w.amount?.toFixed(2)}</div>
                <div style={{ fontSize: 12, color: '#636e72' }}>
                  Astrologer ID: {w.astrologer_id} &bull; Bank: {w.bank_account_id}
                </div>
                <div style={{ fontSize: 11, color: '#b2bec3' }}>
                  {w.created_at
                    ? new Date(w.created_at).toLocaleString('en-IN')
                    : ''}
                </div>
              </div>
              <div style={{ display: 'flex', gap: 8 }}>
                <Badge bg="warning" text="dark">
                  Pending
                </Badge>
                <Button
                  variant="success"
                  size="sm"
                  onClick={() => handleApprove(w.id)}
                  disabled={loading.pendingWithdrawals}
                >
                  Approve
                </Button>
                <Button
                  variant="outline-danger"
                  size="sm"
                  onClick={() => openReject(w.id)}
                >
                  Reject
                </Button>
              </div>
            </div>
          ))}
        </div>
      )}

      {/* Reject Modal */}
      <Modal show={rejectModal.open} onHide={closeReject} centered size="sm">
        <Modal.Header closeButton>
          <Modal.Title style={{ fontSize: 16 }}>Reject Withdrawal</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group>
            <Form.Label style={{ fontSize: 13 }}>Reason for rejection</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              value={rejectModal.reason}
              onChange={(e) => setRejectModal((m) => ({ ...m, reason: e.target.value }))}
              placeholder="Enter reason..."
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" size="sm" onClick={closeReject}>
            Cancel
          </Button>
          <Button
            variant="danger"
            size="sm"
            onClick={handleReject}
            disabled={!rejectModal.reason.trim()}
          >
            Reject
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default AdminWithdrawals;
